module.exports = __webpack_public_path__ + "static/media/nl-NL.9990ba33.md";